// Apolo IDE — E2b · SteeringIndicator chip.
//
// Discreet chip displayed near the composer when project steering files
// (.apollo/steering/) are active for the current session root. Renders
// null when count=0 (no chip, no layout impact).
//
// A11y: aria-label + title tooltip name the chip when reached (WCAG 1.3.1 /
// 4.1.2). It is a PERSISTENT chip, NOT a live region — `role="status"` (implicit
// aria-live) would re-announce "N steering ativos" on every re-render / session
// switch (WCAG 4.1.3 noise), so it is intentionally omitted (F4).
// Style: flat .rx-steering pill from redesign.css (pos-s5 — mono, --rx-text-3,
// surface-1, hairline, fully-rounded; accent only on the icon stroke). NOT the
// glowy .rx-worksum — the steering badge must read quiet, like the reference.

import { Sparkles } from 'lucide-react';

/**
 * @param {{ count: number }} props
 */
export default function SteeringIndicator({ count }) {
  if (!count || count <= 0) return null;

  const label = `${count} steering ativos`;
  const ariaLabel = `${count} arquivos de steering ativos`;

  return (
    <span
      className="rx-steering"
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      <Sparkles size={12} aria-hidden="true" strokeWidth={1.7} />
      <span>{label}</span>
    </span>
  );
}
